<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex lg12">

        <sp-360-panel :title="'management.units.manage-units' | translate">
          <div data-vv-scope="formUnidades">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('formUnidades.nome') }">
                    <div class="input-group">
                      <va-input id="nome" name="nome" required v-model="unidade.nome" v-validate="'required'" label="Nome"/>
                      <!-- 'management.units.name' -->
                    </div>

                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('formUnidades.sigla') }">
                    <div class="input-group">
                      <va-input id="sigla" name="sigla" required v-model="unidade.sigla" v-validate="'required'" label="Sigla"/>
                      <!-- 'management.units.initials' -->
                    </div>

                  </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="button" @click="persiste()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="flex lg12">
                  <va-input class="filter-input"
                    v-model="termo"
                    placeholder="Pesquisar"
                    removable
                    @input="pesquisa"
                  >
                    <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>

                  <sp360-dataTable id="tabelaUnidade" ref="tabelaUnidade"
                    :apiMode="false"
                    :data="dadosUnidadeFiltrados.data"
                    :fields="tableFields"
                    :dataModeFilterableFields="dataModeFilterableFields"
                    :sortFunctions="sortFunctions"
                    :perPage="itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editar($event)"
                    @deletarRow="deletarModal($event)"
                  />
              </div>
            </div>

          </div>
        </sp-360-panel>

      </div>
    </div>
    <va-modal ref="perfilDelModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="deletar()"
                   @cancel="cancelarDelecao()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalDelecao"
                   >
      <template slot="default">
        {{'management.units.confirmationText' | translate}}
      </template>
    </va-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import Multiselect from 'vue-multiselect'
import UnidadeService from '@/services/UnidadeService'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { Multiselect, 'sp360-dataTable': Sp360DataTable, Sp360Panel },
  name: 'usuario',
  computed: {

  },
  data () {
    return {
      termo: null,
      openModalDelecao: false,
      unidade: UnidadeService.newUnidade(),
      dadosUnidade: {
        'data': [],
      },
      dadosUnidadeFiltrados: {
        'data': [],
      },
      itemsPerPage: constantes.TAMANHO_TABELAS,
      tableFields: [
        {
          name: 'id',
          sortField: 'id',
          title: this.$t('management.units.id'),
          width: '5%',
        },
        {
          name: 'sigla',
          sortField: 'sigla',
          title: this.$t('management.units.initials'),
        },
        {
          name: 'nome',
          sortField: 'nome',
          title: this.$t('management.units.name'),
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
        },
      ],
      dataModeFilterableFields: ['nome', 'sigla'],
      sortFunctions: {
        'id': MetodosGlobais.ordenaTabela,
        'sigla': MetodosGlobais.ordenaTabela,
        'nome': MetodosGlobais.ordenaTabela,
      },
    }
  },
  beforeCreate () {
    this.$store.dispatch('unidade/getAllUnidade').then(
      retorno => {
        this.dadosUnidade.data = retorno.data
        this.dadosUnidadeFiltrados.data = retorno.data
        this.updateTabelaUnidade(this.dadosUnidadeFiltrados)
        // this.$refs.tabelaUnidade.update()
      }
    )
  },
  methods: {
    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []

      if((!Number.isNaN(parseInt(term))) && term !="" ){
        a = this.$refs.tabelaUnidade.filterByNumber(this.dadosUnidade.data, this.termo)
      }else{
        a = this.$refs.tabelaUnidade.filterByString(this.dadosUnidade.data, this.termo)
      }
      
      this.dadosUnidadeFiltrados.data = a
      this.updateTabelaUnidade(this.dadosUnidadeFiltrados)
    }, 400),
    valida () {
      return this.$validator.validateAll('formUnidades').then(valid => {
        return valid
      })
    },
    persiste (usuario) {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.unidade.id == 0) {
            this.$store.dispatch('unidade/postUnidadeRetornar', this.unidade)
              .then(retorno => {
                this.showToast(this.$t('management.units.unit') + ` ${retorno.data.sigla}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
                this.limpar()
                this.dadosUnidade.data.push(retorno.data)
                // this.$refs.tabelaUnidade.update()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError'), constantes.TOASTED_ERROR)
              })
          } else {
            let index = _.findIndex(this.dadosUnidade.data, uni => uni.id == this.unidade.id)
            this.$store.dispatch('unidade/putUnidade', this.unidade)
              .then(retorno => {
                this.updateUnidade(this.unidade, index)
                this.showToast(this.$t('management.units.unit') + ` ${this.unidade.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
              })
          }
        }
      })
    },
    updateUnidade (unidade, index) {
      Vue.set(this.dadosUnidade.data, index, unidade)
      // this.$refs.tabelaUnidade.update()
      this.$refs.tabelaUnidade.resetPage()
    },
    editar (event) {
      this.unidade = _.cloneDeep(event.rowData)
    },
    deletarModal (event) {
      this.unidadeADeletar = event.rowData
      this.openModalDelecao = true;
    },
    deletar () {
      this.$store.dispatch('unidade/deleteUnidade', this.unidadeADeletar.id).then(
        retorno => {
          this.showToast(this.$t('management.units.unit') + ` ${this.unidadeADeletar.nome}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
          this.dadosUnidade.data = this.dadosUnidade.data.filter(uni => {
            return uni.id != this.unidadeADeletar.id
          })
          // this.$refs.tabelaUnidade.update()
        }
      )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError'), constantes.TOASTED_ERROR)
        })
    },
    cancelarDelecao () {
      this.unidadeADeletar = {}
    },
    atualiza (usuario) {

    },
    limpar () {
      event.preventDefault()
      this.unidade = UnidadeService.newUnidade()
      this.$validator.reset()
    },
    updateTabelaUnidade(dados){
      this.$set(this.dadosUnidadeFiltrados, 'data', dados.data)
    },
  },
}
</script>

<style lang="scss">
  @import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
    .multiselect__placeholder {
    color: $brand-success;
  }
</style>
